<script setup lang="ts">
import { Badge } from '@/components/ui/badge'

const props = defineProps<{
  status: string
  label?: string
}>()

type BadgeVariant = 'default' | 'secondary' | 'destructive' | 'outline'

const STATUS_VARIANT: Record<string, BadgeVariant> = {
  requested:           'secondary',
  statement_requested: 'secondary',
  sign_requested:      'secondary',
  uploaded:            'default',
  accepted:            'default',
  signed:              'default',
  rejected:            'destructive',
  attached:            'outline',
  sent:                'outline',
}

const STATUS_CLASS: Record<string, string> = {
  uploaded:       'bg-blue-500 hover:bg-blue-500',
  accepted:       'bg-green-500 hover:bg-green-500',
  sign_requested: 'bg-amber-500 hover:bg-amber-500',
  signed:         'bg-green-500 hover:bg-green-500',
}

const displayLabel = props.label ?? props.status.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
</script>

<template>
  <Badge :variant="STATUS_VARIANT[status] ?? 'secondary'" :class="STATUS_CLASS[status] ?? ''">
    {{ displayLabel }}
  </Badge>
</template>
